import { Typography } from 'shared/components/Typography';

export const FrequencyDialogHeader = () => {
  return (
    <Typography as="h3" type="body" fontWeight="semibold" color="black">
      Set frequency
    </Typography>
  );
};
